module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAACpJREFUKFNjTPYx/8+ABuZuOckIEsImxzgcNKB7mBAfHBqkgGERSqTGNAAXsjr/FUp4UAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/detail2.png
// module id = hOYu
// module chunks = 1